// Einwilligungs-Verwaltung (Cookie-Banner). Kategorien: Notwendig (immer), Statistik (Google Analytics), Aufzeichnung (Sitzungsaufzeichnung).
// Gespeichert pro Zone (public / partner / driver). Ältere Entscheidungen ("accepted"/"declined") gelten nur für Statistik –
// für die neue Kategorie Aufzeichnung wird erneut gefragt.
export function getZone() {
  const h = window.location.hostname;
  if (h === "partners.gotransfer24.de") return "partner";
  if (h === "driver.gotransfer24.de") return "driver";
  if (h === "admin.gotransfer24.de") return "admin";
  return "public";
}

const legacyKey = () => `cookie_consent_${getZone() === "admin" ? "public" : getZone()}`;
const v2Key = () => `cookie_consent_v2_${getZone()}`;

/** { decided, analytics, recording } – decided=false: Banner muss gezeigt werden */
export function getConsent() {
  try {
    // Admin-Buchung (Telefon): kein Banner, keine Aufzeichnung, keine Statistik
    if (sessionStorage.getItem("gt24_admin_booking")) return { decided: true, analytics: false, recording: false };
    const raw = localStorage.getItem(v2Key());
    if (raw) {
      const c = JSON.parse(raw);
      return { decided: true, analytics: !!c.analytics, recording: !!c.recording };
    }
    const old = localStorage.getItem(legacyKey());
    if (old === "accepted") return { decided: false, analytics: true, recording: false };
    if (old === "declined") return { decided: false, analytics: false, recording: false };
  } catch { /* Storage nicht verfügbar */ }
  return { decided: false, analytics: false, recording: false };
}

function updateGtag(granted) {
  if (typeof window.gtag === "function") window.gtag("consent", "update", { analytics_storage: granted ? "granted" : "denied" });
}

export function applyStoredConsent() {
  const c = getConsent();
  if (c.decided || c.analytics) updateGtag(c.analytics);
}

export function saveConsent({ analytics, recording }) {
  try {
    localStorage.setItem(v2Key(), JSON.stringify({ analytics: !!analytics, recording: !!recording, ts: Date.now() }));
    localStorage.setItem(legacyKey(), analytics ? "accepted" : "declined"); // Rückwärtskompatibel
  } catch { /* Storage nicht verfügbar */ }
  updateGtag(!!analytics);
  window.dispatchEvent(new Event("consent-changed"));
}
